import { EMPTY_LIST } from '../../../../constants/common'

export function getRequestSummaryWidgetData({
  outdated,
  text,
  warnings = EMPTY_LIST,
}) {
  return {
    can_generate: outdated,
    text,
    warnings,
  }
}

export function getRequestSummaryEmptyWidgetData() {
  return {
    can_generate: true,
    text: null,
    warnings: EMPTY_LIST,
  }
}
